import { Check, X } from "@/components/icons";

/* Shared by all eight /alternatives comparison tables. A boolean renders as a
   labelled Yes/No — the icon is never the only signal — and anything else
   passes straight through as the cell's own text. */

interface Props {
  value: string | boolean;
}

export default function ComparisonCell({ value }: Props) {
  if (value === true) {
    return (
      <span className="flex items-center gap-2">
        <Check
          size={15}
          className="shrink-0"
          style={{ color: "var(--brand-green)" }}
          aria-hidden="true"
        />
        Yes
      </span>
    );
  }
  if (value === false) {
    return (
      <span className="text-muted-foreground flex items-center gap-2">
        <X size={15} className="shrink-0" aria-hidden="true" />
        No
      </span>
    );
  }
  return <>{value}</>;
}
